module.exports = __webpack_public_path__ + "img/76.945ba084.png";